import React from 'react';
export const isStringOrNumber = (o) => {
    return typeof o === 'string' || typeof o === 'number';
};
export const isReactNode = (o) => {
    return React.isValidElement(o) || isStringOrNumber(o);
};
export const isEmpty = (o) => {
    return o === undefined || o === null || (typeof o === 'number' && isNaN(o)) || o === '';
};
export const isArray = (o) => {
    return Object.prototype.toString.call(o) === '[object Array]';
};
export const isObject = (o) => {
    return Object.prototype.toString.call(o) === '[object Object]';
};
export const clone = (source) => {
    if (!source || typeof source !== 'object') {
        throw new Error('error arguments');
    }
    const targetObj = source.constructor === Array
        ? []
        : {};
    for (const keys in source) {
        if (Object.prototype.hasOwnProperty.call(source, keys)) {
            if (source[keys] && typeof source[keys] === 'object') {
                targetObj[keys] = source[keys].constructor === Array ? [] : {};
                targetObj[keys] = clone(source[keys]);
            }
            else {
                targetObj[keys] = source[keys];
            }
        }
    }
    return targetObj;
};
